module.exports = __webpack_public_path__ + "media/images/wedding/thumb/27-fe2a0a43978a2363a07383ffb645c77d.jpg";